module.exports = __webpack_public_path__ + "2e7868531cc26b7c6dd2e218e883ddf1.pdf";